
const runtimeConfig = require('../../functions/src/config/rtc.json')

const configs = {
  test: {
    apiKey: 'AIzaSyD2T0SqFM0c8FnvryvxTlD1AscPUWNMfEI',
    authDomain: 'openlaw-test.firebaseapp.com',
    databaseURL: 'https://openlaw-test.firebaseio.com',
    projectId: 'openlaw-test',
    storageBucket: 'openlaw-test.appspot.com',
    messagingSenderId: '766940877987',
    appId: '1:766940877987:web:7711ff55e4cc08821edb16',
    measurementId: 'G-B24BYQF3LC'
  },
  development: {
    apiKey: 'AIzaSyCZr3F5u67HAkCXO59TxBaVIY7SJu5rKRM',
    authDomain: 'openlaw-dev.firebaseapp.com',
    databaseURL: 'https://openlaw-dev.firebaseio.com',
    projectId: 'openlaw-dev',
    storageBucket: 'openlaw-dev.appspot.com',
    messagingSenderId: '241268186306',
    appId: '1:241268186306:web:7fdb715ec1714c0e63af5b',
    measurementId: 'G-QDT6TYYKX6'
  },
  production: {
    apiKey: 'AIzaSyDJzRHCvHs_4oYayyudoVqULFw_WBm0a2M',
    authDomain: 'openlaw-188314.firebaseapp.com',
    databaseURL: 'https://openlaw-188314.firebaseio.com',
    projectId: 'openlaw-188314',
    storageBucket: 'openlaw-188314.appspot.com',
    messagingSenderId: '119669792775',
    appId: '1:119669792775:web:744583a24ac726ca2f4aa2',
    measurementId: 'G-8H9W4XECNR'
  }
}

export default configs[runtimeConfig.app.env]
